import { connectMediaStore } from '../../_hocs/withOwnReduxStore';
import { getCurrentStreamItems, getIsShowingAddDeviationsPopup, } from '../../selectors';
import { addDeviations, showAddDeviationsPopup, hideAddDeviationsPopup, } from '../../actions';
var mapStateToProps = function (state) { return ({
    currentDeviationIds: getCurrentStreamItems(state),
    isShowingAddDeviationsPopup: getIsShowingAddDeviationsPopup(state),
}); };
var mapDispatchToProps = {
    addDeviations: addDeviations,
    showAddDeviationsPopup: showAddDeviationsPopup,
    hideAddDeviationsPopup: hideAddDeviationsPopup,
};
export default connectMediaStore(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=AddDeviationsButton.container.js.map